<template lang="pug">
section#v-review.container
  h3 2019 智慧製造論壇現場回顧
  h4 5G 智慧未來精彩對談
  .video
    .fb-video(data-href='https://www.facebook.com/TechOrange/videos/2277264058992207/', data-width='720', data-show-text='false')
      blockquote(cite='https://developers.facebook.com/TechOrange/videos/2277264058992207/' class='fb-xfbml-parse-ignore')
        a(href='https://developers.facebook.com/TechOrange/videos/2277264058992207/')
        p 《2019 智慧製造論壇直播中》5G 高速傳輸網路，會為台灣帶來什麼新經濟、新未來？科技報橘為您帶來產官學重量對談，不可錯過！
        | 由
        a(href='https://www.facebook.com/TechOrange/') TechOrange 科技報橘
        | 發佈於 2019年3月7日 星期四
  h4 精彩活動花絮
  .swiper-container.gallery-top
    .swiper-wrapper
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-1.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-2.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-3.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-4.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-5.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-6.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-7.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-8.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-9.jpg")})`}')
    .swiper-button-prev.swiper-button-white
    .swiper-button-next.swiper-button-white
  .swiper-container.gallery-thumbs
    .swiper-wrapper
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-1.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-2.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-3.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-4.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-5.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-6.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-7.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-8.jpg")})`}')
      .swiper-slide(:style='{backgroundImage: `url(${require("@/assets/photo-9.jpg")})`}')
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'Review',
  mounted() {
    new Swiper('.gallery-top', {
      spaceBetween: 10,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: new Swiper('.gallery-thumbs', {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        })
      },
    })
  },
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-review
  padding-bottom: 120px
  padding-top: 60px
  text-align: center
h3
  +font(30px, #222937, null, .29px, bold)
  margin-bottom: 50px
h4
  +font(24px, #FF9106, null, .24px, bold)
  margin-bottom: 40px

.video
  margin-bottom: 130px

.swiper-container
  width: 720px
.swiper-slide
  +background(null)
.gallery-top
  height: 380px
.gallery-thumbs
  background-color: black
  height: 70px
  padding-bottom: 10px
  padding-top: 10px
  .swiper-slide
    cursor: pointer

@media (max-width: 1023px)
  #v-review
    padding-bottom: 60px
    padding-top: 30px
  h3
    +font(20px, null, null, 1px)
    margin-bottom: 40px
  h4
    +font(16px, null, null, .15px)
    margin-bottom: 20px

  .video
    margin-bottom: 40px

  .swiper-container
    max-width: 720px
    width: 100%
  .swiper-button-prev, .swiper-button-next
    display: none !important
  .gallery-top
    height: 56vw
  .gallery-thumbs
    height: 60px
</style>
